/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiDetachCaseTransactionsRequest
 */
export interface InternalApiDetachCaseTransactionsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiDetachCaseTransactionsRequest
     */
    externalIds: Array<string>;
}

/**
 * Check if a given object implements the InternalApiDetachCaseTransactionsRequest interface.
 */
export function instanceOfInternalApiDetachCaseTransactionsRequest(value: object): value is InternalApiDetachCaseTransactionsRequest {
    if (!('externalIds' in value) || value['externalIds'] === undefined) return false;
    return true;
}

export function InternalApiDetachCaseTransactionsRequestFromJSON(json: any): InternalApiDetachCaseTransactionsRequest {
    return InternalApiDetachCaseTransactionsRequestFromJSONTyped(json, false);
}

export function InternalApiDetachCaseTransactionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiDetachCaseTransactionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'externalIds': json['externalIds'],
    };
}

export function InternalApiDetachCaseTransactionsRequestToJSON(json: any): InternalApiDetachCaseTransactionsRequest {
    return InternalApiDetachCaseTransactionsRequestToJSONTyped(json, false);
}

export function InternalApiDetachCaseTransactionsRequestToJSONTyped(value?: InternalApiDetachCaseTransactionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalIds': value['externalIds'],
    };
}

